module.exports = __webpack_public_path__ + "static/Moonlighter5-1c0bb6672e02ecc660367e030a1b50ef.png";